"use client";
import { jsxs as l, jsx as i } from "react/jsx-runtime";
const s = ({
  title: r,
  titleId: n,
  desc: e,
  descId: t,
  ...a
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-cn",
    viewBox: "0 0 640 480",
    "aria-labelledby": n,
    "aria-describedby": t,
    ...a,
    children: [
      e ? /* @__PURE__ */ i("desc", { id: t, children: e }) : null,
      r ? /* @__PURE__ */ i("title", { id: n, children: r }) : null,
      /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("path", { id: "cn-a", fill: "#ff0", d: "M-.6.8 0-1 .6.8-1-.3h2z" }) }),
      /* @__PURE__ */ i("path", { fill: "#ee1c25", d: "M0 0h640v480H0z" }),
      /* @__PURE__ */ i(
        "use",
        {
          xlinkHref: "#cn-a",
          width: 30,
          height: 20,
          transform: "matrix(71.9991 0 0 72 120 120)"
        }
      ),
      /* @__PURE__ */ i(
        "use",
        {
          xlinkHref: "#cn-a",
          width: 30,
          height: 20,
          transform: "matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)"
        }
      ),
      /* @__PURE__ */ i(
        "use",
        {
          xlinkHref: "#cn-a",
          width: 30,
          height: 20,
          transform: "matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)"
        }
      ),
      /* @__PURE__ */ i(
        "use",
        {
          xlinkHref: "#cn-a",
          width: 30,
          height: 20,
          transform: "matrix(6.5991 -23.0749 23.0746 6.59919 288 168)"
        }
      ),
      /* @__PURE__ */ i(
        "use",
        {
          xlinkHref: "#cn-a",
          width: 30,
          height: 20,
          transform: "matrix(14.9991 -18.73557 18.73533 14.99929 240 216)"
        }
      )
    ]
  }
);
export {
  s as default
};
